import React, { useState, useEffect } from 'react';
import axios from 'axios';

export const FacturaSimplificada = ({ empresa, apiKey }) => {
  const [form, setForm] = useState({
    cif: '',
    numero: '',
    fecha: '',
    tipo_factura: 'F2',
    is_intracomunitaria: false,
    is_exportacion: false,
    recargo: false,
    subtotal: null,
    total: null,
  });

  const [lineas, setLineas] = useState([
    { producto: '', cantidad: null, precio: null, impuesto: null, recargo: null, descuento: null},
  ]);

  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');

  // Inicializar CIF desde notasEmpresa
  useEffect(() => {
    try {
      const notas = JSON.parse(empresa.notasEmpresa || '{}');
      if (notas.verifactu?.cif) {
        setForm((prev) => ({ ...prev, cif: notas.verifactu.cif }));
      }
    } catch (err) {
      console.error('Error al cargar CIF desde notasEmpresa', err);
    }
  }, [empresa]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleLineaChange = (index, e) => {
    const { name, value } = e.target;
    const nuevasLineas = [...lineas];
    nuevasLineas[index][name] = ['cantidad','precio','impuesto','recargo','descuento'].includes(name)
      ? parseFloat(value)
      : value;
    setLineas(nuevasLineas);
  };

  const agregarLinea = () => {
    setLineas([...lineas, { producto: '', cantidad: null, precio: null, impuesto: null, recargo: null, descuento: null }]);
  };

  const eliminarLinea = (index) => {
    setLineas(lineas.filter((_, i) => i !== index));
  };

  const enviarFactura = async () => {
    setLoading(true);
    setMensaje('');
    try {
      const payload = {
        factura: {
          ...form,
          is_simplificada: true,
          tipo_factura: 'F2',
          version: '1.0',
        },
        lineas,
      };

      const res = await axios.post(
        'https://facturas-service.cedesa.es/api/v1/subir-factura',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            'X-API-Key': 'fms-ZrXu5oTkJWECmlbNx7uH0Ah6BuVd1C1G',
          },
        }
      );

      setMensaje('Factura simplificada enviada correctamente ✅');
      console.log(res.data);
    } catch (err) {
      console.error(err);
      setMensaje('Error al enviar la factura ❌: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-12 p-6 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold mb-6 text-center">Crear Factura Simplificada</h2>

      {mensaje && <div className="mb-4 p-2 bg-gray-100 text-gray-800 rounded">{mensaje}</div>}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {/* CIF visible pero no editable */}
        <div>
          <label className="block font-medium mb-1">CIF</label>
          <input
            type="text"
            name="cif"
            value={form.cif}
            disabled
            className="w-full border border-gray-300 px-3 py-2 rounded bg-gray-100 cursor-not-allowed"
          />
        </div>

        <label className="block font-medium mb-1">Número identificador de factura</label>
        <input type="text" name="numero" value={form.numero} onChange={handleChange} placeholder="Número" className="w-full border border-gray-300 px-3 py-2 rounded" />
        <label className="block font-medium mb-1">Fecha de emisión</label>
        <input type="date" name="fecha" value={form.fecha} onChange={handleChange} className="w-full border border-gray-300 px-3 py-2 rounded" />
        <label className="block font-medium mb-1">Tipo de factura</label>
        <input type="text" placeholder="Tipo de factura" value={form.tipo_factura} onChange={(e) => setForm({ ...form, tipo_factura: e.target.value })} className="border p-2 rounded"  disabled />

        <label className="flex items-center gap-2">
          <input type="checkbox" name="is_intracomunitaria" checked={form.is_intracomunitaria} onChange={handleChange} />
          Intracomunitaria
        </label>

        <label className="flex items-center gap-2">
          <input type="checkbox" name="is_exportacion" checked={form.is_exportacion} onChange={handleChange} />
          Exportación
        </label>

        <label className="flex items-center gap-2">
          <input type="checkbox" name="recargo" checked={form.recargo} onChange={handleChange} />
          Recargo
        </label>

        <label className="block font-medium mb-1">Subtotal</label>
        <input type="number" step="0.01" name="subtotal" value={form.subtotal} onChange={handleChange} placeholder="Subtotal" className="w-full border border-gray-300 px-3 py-2 rounded" />
        <label className="block font-medium mb-1">Total</label>
        <input type="number" step="0.01" name="total" value={form.total} onChange={handleChange} placeholder="Total" className="w-full border border-gray-300 px-3 py-2 rounded" />
      </div>

      {/* Líneas */}
      <h3 className="text-xl font-semibold mb-2">Líneas de factura</h3>
      {lineas.map((linea, index) => (
        <div key={index} className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-2 items-end">
          <input type="text" name="producto" value={linea.producto} onChange={(e) => handleLineaChange(index, e)} placeholder="Producto" className="border p-2 rounded col-span-2" />
          <input type="number" name="cantidad" value={linea.cantidad} onChange={(e) => handleLineaChange(index, e)} placeholder="Cantidad" className="border p-2 rounded" />
          <input type="number" name="precio" value={linea.precio} onChange={(e) => handleLineaChange(index, e)} placeholder="Precio" className="border p-2 rounded" />
          <input type="number" name="impuesto" value={linea.impuesto} onChange={(e) => handleLineaChange(index, e)} placeholder="Impuesto %" className="border p-2 rounded" />
          <input type="number" name="recargo" value={linea.recargo} onChange={(e) => handleLineaChange(index, e)} placeholder="Recargo" className="border p-2 rounded" />
          <input type="number" name="descuento" value={linea.descuento} onChange={(e) => handleLineaChange(index, e)} placeholder="Descuento" className="border p-2 rounded" />
          <button onClick={() => eliminarLinea(index)} className="px-2 py-1 bg-red-500 text-white rounded mt-4 hover:bg-red-600">Eliminar</button>
        </div>
      ))}

      <button onClick={agregarLinea} className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300 mt-2 mb-4">Agregar línea</button>

      <button onClick={enviarFactura} disabled={loading} className="mt-6 w-full py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
        {loading ? 'Enviando...' : 'Enviar factura'}
      </button>
    </div>
  );
};
